import { render, staticRenderFns } from "./StockRSI.vue?vue&type=template&id=345a8704&scoped=true"
import script from "./StockRSI.vue?vue&type=script&lang=js"
export * from "./StockRSI.vue?vue&type=script&lang=js"
import style0 from "./StockRSI.vue?vue&type=style&index=0&id=345a8704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345a8704",
  null
  
)

export default component.exports